module.exports = "/_next/static/images/kate-hudson-e4107a9c832bc533094e49ae180397f2.png";